import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

export const httpHeaderInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const router = inject(Router);

  const currentUrl = router.url;

  const modifiedRequest = request.clone({
    setHeaders: {
      'X-Page-Path': currentUrl,
    },
  });

  return next(modifiedRequest);
};
